import { SportTeamsListBlockCombinedProps } from './types';

const usePresenter = (props: SportTeamsListBlockCombinedProps): SportTeamsListBlockCombinedProps => {
  return props;
};

export default usePresenter;
